
<template>
  <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
      <span>{{name}}</span>
    </div>
    <div class="text item paramContainer"> 
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="8">
            This action has no parameters to configure. 
        </el-col>
      </el-row>  
      
      <div class="tip">
          {{desc}}
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'SuccessState',
  data () {
    return {
      name: 'Success state',
      desc: '',
    }
  }, 
  props: {
      model: {
          type: Object,
          default: () => {}
      },
  },
  methods: {
   
  },
}
</script>
